<gridster [options]="options" class="mat-drawer-container bg-white" [ngStyle]="{'max-height.px':sizeY,'width':'100%'}" style="background-color: white;">
    <gridster-item [item]="item.config" *ngFor="let item of gridItems;let i = index" class="subject-widget no-shadow" [tabindex]="i">
        <div class="mat-card no-padding" style="height: 100%;">
        <ndc-dynamic [ndcDynamicComponent]="item.widget" [ndcDynamicInputs]="item.metadata" [ndcDynamicOutputs]="handleValueChanged" ></ndc-dynamic>
        </div>
    </gridster-item>
</gridster>
